import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import Question from '../Question'
import Step from './Step'
import FirstStep from './FirstStep'
import LastStep from './LastStep'

@inject('surveyState')
@observer
export default class StepMode extends Component {
  render() {
    const { surveyState, onFinish, onBack, onNext } = this.props
    const { currentStep, currentQuestion, tokens } = surveyState

    return surveyState.isLastStep ? (
      <LastStep
        editButton={currentStep.backButton}
        submitButton={currentStep.nextButton}
        onEdit={onBack}
        onSubmit={onFinish}
        submitting={surveyState.submitting || surveyState.isRedirecting}
        title={currentStep.title}
        description={currentStep.description}
      />
    ) : (
      <Step>
        {surveyState.isFirstStep ? (
          <FirstStep
            onStart={onNext}
            name={tokens ? tokens.first_name : ''}
            mapped={currentQuestion}
          />
        ) : (
          <Question mapped={currentQuestion} />
        )}
      </Step>
    )
  }
}
